import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../components/Button';
import { supabase } from '../lib/supabase';
import { ProtectedLayout } from '../components/ProtectedLayout';

export function PaymentConfirmation() {
  const navigate = useNavigate();
  const location = useLocation();
  const [coreValues, setCoreValues] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // Get the amount from the URL query parameter
  const searchParams = new URLSearchParams(location.search);
  const customAmount = searchParams.get('amount') || '5';

  // Calculate the next billing date (one month from now)
  const today = new Date();
  const nextBillingDate = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
  const billingDateString = nextBillingDate.toLocaleDateString(undefined, { month: 'long', day: 'numeric' });

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          navigate('/');
          return;
        }

        // Fetch core values
        const { data: profile } = await supabase
          .from('profiles')
          .select('core_value_1, core_value_2, core_value_3')
          .eq('id', user.id)
          .single();

        if (profile) {
          setCoreValues([
            profile.core_value_1,
            profile.core_value_2,
            profile.core_value_3
          ].filter(Boolean));
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, [navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-white to-blue-50 flex items-center justify-center">
        <div className="text-[#236caf]">Loading...</div>
      </div>
    );
  }

  return (
    <ProtectedLayout>
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50 flex items-center justify-center p-6">
      <div className="max-w-3xl w-full bg-white rounded-xl shadow-lg p-8 space-y-6">
        <h1 className="text-3xl font-bold text-[#004060]">Welcome to the FearGo App!</h1>
        <p className="text-xl text-gray-600">
          We are here to help you use your fears to go places.
        </p>
        <p className="text-gray-700">
          You are signed up for ${customAmount}/month, and you'll be charged monthly on {billingDateString}. You can change or cancel that anytime in your Profile Settings. Remember, it's motivation-based pricing, so always go with pricing that motivates you.
        </p>
        <p className="text-gray-700">
          Again, thank you and welcome. But now let's get to work.
        </p>
        <p className="text-gray-700">
          Click the dashboard button, and open the celebrate and capture section and document what you learned from going through this onboarding process.</p>
        <p className="text-gray-700">
          Whatever you put is perfect and is the first step. Then tomorrow you'll journal, take action, document a new lesson learned. The whole process takes 10-15 minutes and you'll grow personally and professionally.
        </p>
        <p className="text-gray-700">
          Cheers to you and have fun,
        </p>
        <p className="text-gray-700 font-medium">
          Joey
        </p>
        <Button onClick={() => navigate('/dashboard')} className="w-full">
          Go to Dashboard
        </Button>
      </div>
    </div>
    </ProtectedLayout>
  );
}